
export const getTypesAsProps = types => (
  types.reduce((taxIdTypesObj, taxIdType) => {
    const newObj = taxIdTypesObj;
    newObj[taxIdType.value] = {
      value: taxIdType.value,
      name: taxIdType.name,
      sortOrder: taxIdType.sortOrder,
    };
    return newObj;
  }, {})
);
